import { matchPath } from 'react-router-dom';
import { PortalVersion } from 'src/app/data/common/portalVersion';
import RoleID from 'src/app/data/common/interfaces/RoleID';
import ROUTE_PATHS from 'src/routing/paths';

/**
 * Legacy pages an Account Owner can still open from a direct link (e.g. a shared learner
 * recording) without being forwarded to the new admin experience.
 */
const ACCOUNT_OWNER_DEEP_LINK_PATHS = [
  ROUTE_PATHS.NEXT_GEN_LEARNER_SESSION_REPORT,
  ROUTE_PATHS.NEXT_GEN_LEARNER_SESSION_REPORT_EMBEDDED,
];

export const isAccountOwnerDeepLink = (pathname: string | undefined): boolean =>
  !!pathname && ACCOUNT_OWNER_DEEP_LINK_PATHS.some(path => !!matchPath(pathname, { path, exact: true }));

/**
 * Redirects the user to the appropriate new-experience application based on their role,
 * when the new admin experience toggle (`portal_version`) is active.
 *
 * Only fires when `portalVersion === PortalVersion.NEW_PORTAL` (value 1).
 * - RoleID.BUYER → `/program-admin` (nextgen admin experience), unless `currentPath` is one of
 *   the deep-linkable legacy pages above. Callers that redirect on page load pass the current
 *   path; an explicit role switch omits it and always redirects.
 * All other roles do nothing. Learners navigate to the new experience
 * voluntarily via the "On-Demand Simulations" button in the portal header.
 *
 * Uses path-only same-domain redirects via `window.location.replace`.
 * No hostname manipulation of any kind.
 */
const redirectToNewExperience = (
  portalVersion: number | undefined | null,
  roleID: string | undefined,
  currentPath?: string,
): void => {
  if (portalVersion === undefined || portalVersion === null) {
    return;
  }

  if (portalVersion !== PortalVersion.NEW_PORTAL) {
    return;
  }

  if (roleID === RoleID.BUYER) {
    if (isAccountOwnerDeepLink(currentPath)) {
      return;
    }
    window.location.replace('/program-admin');
    return;
  }
};

export default redirectToNewExperience;
